<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Ride Reports</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item"><a href="/">Reports</a>
                            </li>
                            <li class="breadcrumb-item active">Ride Reports
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <form @submit.prevent="filterData">
                    <div class="d-flex justify-content-center mt-2 mb-2">
                        <div class="col-xl-4 col-md-4">
                            <label>Start date</label><br/>
                            <input type="date" v-model="reportFilter.start_date" class="form-control" required>
                        </div>

                        <div class="col-xl-4 col-md-4">
                            <label>End date</label><br/>
                            <input type="date" v-model="reportFilter.end_date" class="form-control" required>
                        </div>

                        <div class="col-xl-4 col-md-4">
                            <label>&nbsp;</label><br/>
                            <button type="submit" class="btn btn-primary">Filter</button>
                            <button type="button" class="btn btn-default" @click="resetFilter">Reset</button>
                        </div>
                    </div>
                </form>
                <div class="card-body pt-3">
                    <div class="row">
                        <div class="col-md-4 mb-1">
                            <div class="stat-card">
                                <i class="fa fa-car stat-icon text-secondary"></i>
                                <div class="stat-label">Total Ride Requests</div>
                                <div class="stat-value">{{ total_ride_requests }}</div>
                            </div>
                        </div>
                        <div class="col-md-4 mb-1">
                            <div class="stat-card">
                                <i class="fa fa-check-circle stat-icon text-success"></i>
                                <div class="stat-label">Total Completed Rides</div>
                                <div class="stat-value">{{ total_rides }}</div>
                            </div>
                        </div>

                        <div class="col-md-4 mb-1">
                            <div class="stat-card">
                                <i class="fa fa-thumbs-up stat-icon text-primary"></i>
                                <div class="stat-label">Average Delivery time</div>
                                <div class="stat-value">{{ avg_delivery_time }}</div>
                            </div>
                        </div>
                    </div>

                    <p class="text-center">
                        <b>{{ periodData }}</b>
                    </p>
                </div>
            </section>
<!--            <div class="card">-->
<!--                <div class="card-content">-->
<!--                    <div class="card-body">-->
<!--                        <div class="col-12">-->
<!--                            <h5 class="mb-3 font-weight-bold">Top Pickup zones</h5>-->
<!--                            <div class="table-responsive">-->
<!--                                <table class="table mb-0">-->
<!--                                    <thead>-->
<!--                                    <tr>-->
<!--                                        <th>Zone</th>-->
<!--                                        <th>No of Pickups</th>-->
<!--                                    </tr>-->
<!--                                    </thead>-->
<!--                                    <tbody>-->
<!--&lt;!&ndash;                                    <tr v-for="trip in driverData.trips" class="mb-2 p-3">&ndash;&gt;-->
<!--&lt;!&ndash;                                        <th>{{ truncateText(trip.pickup_address) }}</th>&ndash;&gt;-->
<!--&lt;!&ndash;                                        <th>{{ truncateText(trip.drop_address) }}</th>&ndash;&gt;-->
<!--&lt;!&ndash;                                        <th>{{ formatDateTime(trip.start_time) }}</th>&ndash;&gt;-->
<!--&lt;!&ndash;                                        <th>&ndash;&gt;-->
<!--&lt;!&ndash;                                                    <span :class="'badge-glow badge badge-' + tripStatus(trip.status)">&ndash;&gt;-->
<!--&lt;!&ndash;                                                        {{ trip.status }}&ndash;&gt;-->
<!--&lt;!&ndash;                                                    </span>&ndash;&gt;-->
<!--&lt;!&ndash;                                        </th>&ndash;&gt;-->
<!--&lt;!&ndash;                                    </tr>&ndash;&gt;-->
<!--                                    </tbody>-->
<!--                                </table>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="card">-->
<!--                <div class="card-content">-->
<!--                    <div class="card-body">-->
<!--                        <div class="col-12">-->
<!--                            <h5 class="mb-3 font-weight-bold">Top Drop-off zones</h5>-->
<!--                            <div class="table-responsive">-->
<!--                                <table class="table mb-0">-->
<!--                                    <thead>-->
<!--                                    <tr>-->
<!--                                        <th>Zone</th>-->
<!--                                        <th>No of Drop-offs</th>-->
<!--                                    </tr>-->
<!--                                    </thead>-->
<!--                                    <tbody>-->
<!--                                    &lt;!&ndash;                                    <tr v-for="trip in driverData.trips" class="mb-2 p-3">&ndash;&gt;-->
<!--                                    &lt;!&ndash;                                        <th>{{ truncateText(trip.pickup_address) }}</th>&ndash;&gt;-->
<!--                                    &lt;!&ndash;                                        <th>{{ truncateText(trip.drop_address) }}</th>&ndash;&gt;-->
<!--                                    &lt;!&ndash;                                        <th>{{ formatDateTime(trip.start_time) }}</th>&ndash;&gt;-->
<!--                                    &lt;!&ndash;                                        <th>&ndash;&gt;-->
<!--                                    &lt;!&ndash;                                                    <span :class="'badge-glow badge badge-' + tripStatus(trip.status)">&ndash;&gt;-->
<!--                                    &lt;!&ndash;                                                        {{ trip.status }}&ndash;&gt;-->
<!--                                    &lt;!&ndash;                                                    </span>&ndash;&gt;-->
<!--                                    &lt;!&ndash;                                        </th>&ndash;&gt;-->
<!--                                    &lt;!&ndash;                                    </tr>&ndash;&gt;-->
<!--                                    </tbody>-->
<!--                                </table>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import {Link} from '@inertiajs/inertia-vue';
import BarChart from "../../Shared/BarChart";

export default {
    metaInfo: {title: 'Ride Reports'},
    props: ['totalRides', 'totalRideRequests', 'avgDeliveryTime', 'period'],
    layout: Layout,
    name: 'RideReport',
    components: {
        BarChart,
        Link,
    },
    mixins: [],
    data: () => ({
        reportFilter : {
            start_date: '',
            end_date: ''
        },
        total_rides: '',
        total_ride_requests: '',
        avg_delivery_time: '',
        periodData: '',
        excelData: {},
    }),
    mounted() {
        this.total_rides = this.totalRides;
        this.total_ride_requests = this.totalRideRequests;
        this.avg_delivery_time = this.avgDeliveryTime;
        this.periodData = this.period;
    },

    methods: {
        generateReportDataset(report, label) {
            let reportData = {
                labels: [],
                datasets: [],
            }
            let data = []

            for (const key in report) {
                reportData.labels.push(key);
                data.push(report[key]);
            }

            reportData.datasets.push({
                label: label ?? 'Signup Reports',
                backgroundColor: '#00B5B8',
                data
            })
            return reportData;
        },
        generateReportName(name, fileType) {
            let now = new Date();
            let formatted = now.getFullYear() + '-' +
                String(now.getMonth() + 1).padStart(2, '0') + '-' +
                String(now.getDate()).padStart(2, '0') + '_' +
                String(now.getHours()).padStart(2, '0') + '-' +
                String(now.getMinutes()).padStart(2, '0') + '-' +
                String(now.getSeconds()).padStart(2, '0');

            return `${name}_${formatted}${fileType}`;
        },
        async filterData() {
            try {
                let results = await axios.get(route("admin.reports.rides"), {
                    params: {
                        start_date: this.reportFilter.start_date,
                        end_date: this.reportFilter.end_date,
                        api: true
                    },
                    headers: {
                        "X-Requested-With": "XMLHttpRequest",
                    },
                });

                this.total_rides = results.data.totalRides;
                this.total_ride_requests = results.data.totalRideRequests;
                this.avg_delivery_time = results.data.avgDeliveryTime;
                this.periodData = results.data.period;
            } catch (e) {
              console.log(e);
            }
      },

        async resetFilter() {
            this.reportFilter = {
              start_date: '',
              end_date: ''
            }

            await this.filterData();
        },
    },
    computed: {
        formattedData() {
            const rows = [];

            // Create a row for column headers
            rows.push(['Device', 'Total']);

            // Add rows for each key-value pair in reportData
            for (const key in this.excelData) {
                rows.push([key, this.excelData[key]]);
            }

            return rows;
        }
    }
}
</script>
